import { useLingui } from '@lingui/react/macro';
import { useMemo } from 'react';

export function useFormTranslations() {
  const { t } = useLingui();

  return useMemo(() => {
    return {
      actions: {
        success: {
          title: t`Saved`,
          message: t`Item was successfully saved.`,
        },
        fail: {
          title: t`Save failed`,
          message: t`Form contains errors.`,
        },
      },
      errors: {
        required: t`Field is required.`,
      },
      labels: {
        optional: t`optional`,
      },
    };
  }, [t]);
}
